import React from 'react';
import { Button } from './Button';
import { Icon } from './Icon';
import { useLanguage } from '../contexts/LanguageContext';
export function Bio() {
  const {
    t
  } = useLanguage();
  return <section className="py-20 md:py-32 px-6 bg-gradient-to-b from-[#0a0a0a] to-[#1a1a1a]" data-id="element-8">
      <div className="max-w-7xl mx-auto" data-id="element-9">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center" data-id="element-10">
          {/* Text Content - Centered on Mobile */}
          <div className="order-2 lg:order-1 animate-fade-in text-center lg:text-left" data-id="element-11">
            <span className="inline-block text-[#C5A028] text-xs font-medium tracking-[0.2em] uppercase mb-4" data-id="element-12">
              {t('bio.label')}
            </span>

            <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-white mb-6 tracking-tight leading-[1.15]" data-id="element-13">
              Alexaaa Narvaez
            </h2>

            <p className="text-base md:text-lg text-white/60 font-light leading-relaxed mb-5" data-id="element-14">
              {t('bio.description1')}
            </p>

            <p className="text-sm md:text-base text-white/50 font-light leading-relaxed mb-8" data-id="element-15">
              {t('bio.description2')}
            </p>

            <div className="space-y-4 mb-10 pb-10 border-b border-white/10" data-id="element-16">
              <div className="flex items-start gap-4 text-left" data-id="element-17">
                <div className="w-10 h-10 rounded-sm bg-[#C5A028]/10 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-18">
                  <Icon name="camera" size={18} className="text-[#C5A028]" data-id="element-19" />
                </div>
                <div data-id="element-20">
                  <h3 className="text-white text-sm font-medium mb-1" data-id="element-21">
                    {t('bio.feature1.title')}
                  </h3>
                  <p className="text-white/50 text-sm font-light leading-relaxed" data-id="element-22">
                    {t('bio.feature1.desc')}
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4 text-left" data-id="element-23">
                <div className="w-10 h-10 rounded-sm bg-[#C5A028]/10 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-24">
                  <Icon name="film" size={18} className="text-[#C5A028]" data-id="element-25" />
                </div>
                <div data-id="element-26">
                  <h3 className="text-white text-sm font-medium mb-1" data-id="element-27">
                    {t('bio.feature2.title')}
                  </h3>
                  <p className="text-white/50 text-sm font-light leading-relaxed" data-id="element-28">
                    {t('bio.feature2.desc')}
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4 text-left" data-id="element-29">
                <div className="w-10 h-10 rounded-sm bg-[#C5A028]/10 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-30">
                  <Icon name="sparkle" size={18} className="text-[#C5A028]" data-id="element-31" />
                </div>
                <div data-id="element-32">
                  <h3 className="text-white text-sm font-medium mb-1" data-id="element-33">
                    {t('bio.feature3.title')}
                  </h3>
                  <p className="text-white/50 text-sm font-light leading-relaxed" data-id="element-34">
                    {t('bio.feature3.desc')}
                  </p>
                </div>
              </div>
            </div>

            {/* CTA Centered on Mobile, Full Width */}
            <div className="flex justify-center lg:justify-start" data-id="element-35">
              <Button href="https://backstage.cam/u/alexaaa-narvaez" variant="secondary" className="w-full lg:w-auto" data-id="element-36">
                <span data-id="element-37">{t('bio.cta')}</span>
              </Button>
            </div>
          </div>

          {/* Image with Artistic Overlay */}
          <div className="order-1 lg:order-2 animate-fade-in-delay-1" data-id="element-38">
            <div className="relative group" data-id="element-39">
              {/* Glow Effect */}
              <div className="absolute -inset-6 bg-gradient-to-br from-[#C5A028]/20 via-transparent to-transparent rounded-sm blur-3xl opacity-60" data-id="element-40" />

              {/* Image Container */}
              <div className="relative overflow-hidden rounded-sm" data-id="element-41">
                <img src="https://cdn.magicpatterns.com/uploads/pUXVahmqVccsp1oLQ6FBMM/IMG_6519.JPG.jpg" alt="Alexaaa Narvaez - Modelo Profesional" className="relative w-full aspect-[3/4] object-cover" style={{
                filter: 'brightness(0.95) contrast(1.05)'
              }} data-id="element-42" />

                {/* Lighter Overlay for Better Visibility */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-black/10" data-id="element-43" />

                {/* Editorial Frame */}
                <div className="absolute inset-0 border border-white/10" data-id="element-44" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}